import {API} from 'constants/api';

// types for api calls
import {
  loginRequesRequestPayload,
  resetPasswordRequestPayload,
  verifyOTPRequestPayload,
  resendOTPRequestPayload,
  resetPasswordOtpRequestPayload,
  setNewPasswordRequestPayload,
  registerOrganizationRequestPayload,
  resendRegisterOrganizationOTPRequestPayload,
  verifyRegisterOrganizationOTPRequestPayload,
} from 'redux/slices/authSlice';
import {createAxiosInstance} from './axiosConfig';
import {
  getBacklogsRequestParams,
  addUserStoryRequestPayload,
  getUserStoryDetailsParams,
  updateUserStoryDetailsPayload,
  deleteUserStoryDetailsPayload,
  validateUserStoryRequestPayload,
} from 'redux/slices/userStorySlice';
import {getDashboardRequestParams} from 'redux/slices/projectAnalyticsSlice';
import {
  addEmployeeRequestPayload,
  getEmployeesRequestParams,
  getEmployeeDetailsParam,
  updateEmployeeDetailsParams,
} from 'redux/slices/employeeSlice';
import {
  addProjectRequestPayload,
  addEmployeeToProjectRequestPayload,
  getProjectsRequestParams,
  updateProjectRequestPayload,
  getProjectDetailsParams,
  getProjectMemberParams,
} from 'redux/slices/projectSlice';
import {smartSearchRequestParams} from 'redux/slices/dashboardSlice';

import {ACCESS_KEY} from 'constants/keys';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {updateProfileDetailsParams} from 'redux/slices/myProfileSlice';

const defaultHeaders = {
  'Content-Type': 'application/json',
};
const multipartHeaders = {
  'Content-Type': 'multipart/form-data',
};
const authHeaders: {Authorization: string} = {Authorization: ''};

export function setAuthHeader(token: string) {
  authHeaders.Authorization = `Bearer ${token}`;
}
// Function to set the auth header dynamically
AsyncStorage.getItem(ACCESS_KEY).then(token => {
  if (token) {
    setAuthHeader(token);
  }
});

// This is for example
export function demo(values: any) {
  return createAxiosInstance({
    url: API.noAuthUrls.demo,
    method: 'POST',
    headers: {...defaultHeaders},
    data: values,
  });
}

// pre booking api
export function preBooking(email: string) {
  return createAxiosInstance({
    url: API.noAuthUrls.preBooking,
    method: 'POST',
    headers: {...defaultHeaders},
    data: {
      email_id: email,
    },
  });
}

// FAQ api
export function askQuestion(email: string, question: string) {
  return createAxiosInstance({
    url: API.noAuthUrls.faq,
    method: 'POST',
    headers: {...defaultHeaders},
    data: {
      email_id: email,
      question,
    },
  });
}

// Login api
export async function signIn(data: loginRequesRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.noAuthUrls.login,
      method: 'POST',
      headers: {...defaultHeaders},
      data: data,
    });
    // set auth header

    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// get project api
export async function getProject(params: getProjectsRequestParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projects,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });

    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

//get employee api
export async function getEmployee(params: getEmployeesRequestParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.employees,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function addProject(data: addProjectRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projects,
      method: 'POST',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });

    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}
// add employee api
export async function addEmployee(data: addEmployeeRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.employees,
      method: 'POST',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });

    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// add employee to project api
export async function addEmployeeToProject(
  data: addEmployeeToProjectRequestPayload,
) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projectTeam,
      method: 'POST',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });

    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function getPojectDashboard(params: getDashboardRequestParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projectDashboard,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function getBacklogs(params: getBacklogsRequestParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.backlogs,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function getEmployeeDetails(params: getEmployeeDetailsParam) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.employeeDetails,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

//update project api
export async function updateProject(data: updateProjectRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projectDetails,
      method: 'PATCH',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

/**
 * get project details API
 */

export async function getProjectDetails(params: getProjectDetailsParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projectDetails,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// api for add user story
export async function addUserStory(data: addUserStoryRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.userStory,
      method: 'POST',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

//update employee details api
export async function updateEmployee(data: updateEmployeeDetailsParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.employeeDetails,
      method: 'PATCH',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

//  get user story details
export async function getUserStoryDetails(params: getUserStoryDetailsParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.userStoryDetails,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// update story details
export async function updateStoryDetails(data: updateUserStoryDetailsPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.userStory,
      method: 'PATCH',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// delete user story
export async function deleteStory(params: deleteUserStoryDetailsPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.userStoryDetails,
      method: 'DELETE',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// project team member
export async function projectTeamMembers(params: getProjectMemberParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.projectTeam,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}
// get profile details
export async function getProfile() {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.profile,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// reset password otp
export async function resetPasswordOtp(data: resetPasswordOtpRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.resetPasswordOtp,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// update profile details
export async function updateProfile(data: updateProfileDetailsParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.profile,
      method: 'PATCH',
      headers: {...multipartHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function verifyOTP(data: verifyOTPRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.verifyOtp,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function resendOTP(data: resendOTPRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.resendOtp,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// reset password
export async function resetPassword(data: resetPasswordRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.resetPassword,
      method: 'POST',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// set new password
export async function setNewPassword(data: setNewPasswordRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.setNewPassword,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// smart search
export async function smartSearch(params: smartSearchRequestParams) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.smartSearch,
      method: 'GET',
      headers: {...defaultHeaders, ...authHeaders},
      params,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

// validate user story
export async function validateUserStory(data: validateUserStoryRequestPayload) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.validateUserStory,
      method: 'PATCH',
      headers: {...defaultHeaders, ...authHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function registerOrgnization(
  data: registerOrganizationRequestPayload,
) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.registerOrganization,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function verifyRegisterOrganizationOTP(
  data: verifyRegisterOrganizationOTPRequestPayload,
) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.verifyRegisterOrganizationOTP,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

export async function resendRegisterOrganizationOTP(
  data: resendRegisterOrganizationOTPRequestPayload,
) {
  try {
    const response = await createAxiosInstance({
      url: API.authUrls.resendRegisterOrganizationOTP,
      method: 'POST',
      headers: {...defaultHeaders},
      data,
    });
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
}

